/* eslint-disable @typescript-eslint/no-unused-vars */

const noop = () => {
	// Do nothing
};

const noopBoolean = () => false;

const noopParameters = (..._args: unknown[]) => {
	// Do nothing
};

export { noop, noopBoolean, noopParameters };

export default noop;
